// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__L0xZ4","bigColWidth":"Table_bigColWidth__bR_qB","biggerColWidth":"Table_biggerColWidth__fQu8K","row":"Table_row__2dpei","col":"Table_col__2f0ap"};